import configs from './configs'

const customerKey = process.env.CUSTOMER

if (!customerKey) {
  throw new Error('Missing CUSTOMER. Please run a customer build script, such as npm run build:xiyuebiaoju.')
}

if (!configs[customerKey]) {
  throw new Error(`Unknown CUSTOMER "${customerKey}". Please add it to src/customer/configs.js first.`)
}

const customer = configs[customerKey]

export default customer



// WEBPACK FOOTER //
// ./src/customer/index.js